module.exports = __webpack_public_path__ + "img/bankcode4.1ce0b53a.png";